export const environment = {
  production: false,
  ENV: 'ACPT',
  API: 'https://api-acpt.vsp.com/reference-inventoryportalapi/inventoryportalitems',
  oauthApiUrl: 'https://api-acpt.vsp.com',
  oauthClientId: 'reference-inventoryportal-ui',
  oauthRedirectUrl: 'https://inventory-acpt.vsp.com/oauth_callback',
  oauthScopes: 'auth_employee_sso openid profile reference_view',
  openIdUrl: 'https://api-staging.vspglobal.com/idp/userinfo.openid',
  requiredAdGroups: []
};
